import React, { useContext } from "react";
import { GlobalsContext } from "../../../../components/Context/globalsContext";

const ResourceGroup = ({ title, groupName, resources, renderHtml }) => {
  const filteredResources = resources.filter(
    (resource) => resource.resourceGroup === groupName
  );

  if (filteredResources.length === 0) return null;

  return (
    <div className="resource-group">
      <h3>{title}</h3>
      <hr />
      {filteredResources.map((resource, index) => (
        <div key={index}>
          <h4>{resource.resourceTitle}</h4>
          {resource.resourceDate && (
            <div dangerouslySetInnerHTML={renderHtml(resource.resourceDate.date)}></div>
          )}
          <div dangerouslySetInnerHTML={renderHtml(resource.description)}></div>
          {resource.linkToResource && (
            <a
              className="btn-bg-cst mb-5"
              href={resource.linkToResource}
              target="_blank"
            >
              {resource.resourceLinkTitle}
            </a>
          )}
        </div>
      ))}
    </div>
  );
};

const LargeFirmResourceLibrary = () => {
  const { state: globalsContext } = useContext(GlobalsContext);

  const renderHtml = (htmlTag) => {
    return { __html: htmlTag };
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="px-4">
        <ResourceGroup
          title="Featured Resources"
          groupName="Featured Resources"
          resources={globalsContext?.globals?.resourceLibrary || []}
          renderHtml={renderHtml}
        />
        <ResourceGroup
          title="Resources"
          groupName="Special Resources"
          resources={globalsContext?.globals?.resourceLibrary || []}
          renderHtml={renderHtml}
        />
        <ResourceGroup
          title="Quarterly Inspiration Calls"
          groupName="Quarterly Inspiration Calls"
          resources={globalsContext?.globals?.resourceLibrary || []}
          renderHtml={renderHtml}
        />
      </div>
      <div className="px-4">
        <ResourceGroup
          title="KA Resources"
          groupName="KA Resources"
          resources={globalsContext?.globals?.resourceLibrary || []}
          renderHtml={renderHtml}
        />
        <ResourceGroup
          title="Monthly Study Group Calls"
          groupName="Monthly Study Group Calls"
          resources={globalsContext?.globals?.resourceLibrary || []}
          renderHtml={renderHtml}
        />
      </div>
    </div>
  );
};

export default LargeFirmResourceLibrary;
